module.exports = __webpack_public_path__ + "img/close.24cf5ef9.svg";